export const PRICE_TYPES = {
    SALE: 'WEEKLY_SALE',
    NET: 'NET',
    RETAIL: 'RETAIL',
    SOLD: 'SOLD',
    HOLD: 'HOLD',
    HOLD_CUSTOM: 'HOLD_CUSTOM',
    UNAVAILABLE: 'UNAVAILABLE',
    PUR: 'PUR',
};

export const TEXT_PRICE_TYPES = [PRICE_TYPES.SOLD, PRICE_TYPES.UNAVAILABLE, PRICE_TYPES.PUR];

export const TEXT_SIZE_SMALL = 'small';
export const TEXT_SIZE_MEDIUM = 'medium';
